import { Button, Link } from 'zudoku/components'

import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "zudoku/ui/Card";

export type Props = {
    title: string,
    description: string,
    path: string
}

export const ApiCard = ({ title, description, path } : Props) => {
    return (
        <Card>
            <CardHeader>
                <CardTitle>{title}</CardTitle>
                <CardDescription>{description}</CardDescription>
            </CardHeader>
            <CardFooter className="flex">
                <Button asChild className="w-full">
                    <Link to={path}>View Documentation</Link>
                </Button>
            </CardFooter>
        </Card>
    )
}